module.exports = __webpack_public_path__ + "static/img/rlzx.74f6efd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jianjie/rlzx.png
// module id = MMHX
// module chunks = 171